export const REQUEST_EDIT_UPDATE_ACCOUNT =
	"REQUEST_EDIT_UPDATE_ACCOUNT";